export default __webpack_public_path__ + "static/media/Standard06.9f09cce1.png";